import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { I18NextModule } from 'angular-i18next';
import { PageNotFoundComponent } from '../../components/page-not-found/page-not-found.component';
import { Paths } from '../../enums/paths.enum';
import { RouteLabels } from '../../enums/routeLabels.enum';
import { AuthGuard } from '../../shared/auth.guard';
import { CanDeactivateGuard } from '../../shared/can-deactivate.guard';
import { FinancialStatementEditPage } from '../ms-annual-reports/financial-statement-edit/financial-statement-edit.page';
// REV-21518: the content pages are REUSED from cpmm (same classes, no fork). Only the navigation
// host (AbcpPage vs CpmmPage) differs between the two sibling route trees.
import { ClosingWorkflowPage } from '../cpmm/closing-workflow/closing-workflow.page';
import { MandateManagementPage } from '../cpmm/mandate-management/mandate-management.page';

// Children mirror CpmmModule exactly: default → mandate-management, the two workflow pages, and the
// `:id` catch-all → FinancialStatementEditPage (this is what the "Bericht" module resolves to; the
// report editor reads the ACTIVE report from state, so the `:id` segment is only a label — D2).
const routes: Routes = [
    {
        path: '',
        children: [
            { path: '', redirectTo: `${Paths.MANDATE_MANAGEMENT}`, pathMatch: 'full' },
            {
                path: `${Paths.MANDATE_MANAGEMENT}`,
                component: MandateManagementPage,
                canActivate: [AuthGuard],
                canDeactivate: [CanDeactivateGuard],
                data: {
                    label: RouteLabels.REPORT_MANDATE_MANAGEMENT,
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                },
            },
            {
                path: `${Paths.CLOSING_WORKFLOW}`,
                component: ClosingWorkflowPage,
                canActivate: [AuthGuard],
                canDeactivate: [CanDeactivateGuard],
                data: {
                    label: RouteLabels.REPORT_CLOSING_WORKFLOW,
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                },
            },
            {
                path: `${Paths.CLOSING}`,
                loadChildren: () => import('./closing/closing.module').then((m) => m.ClosingModule),
                canActivate: [AuthGuard],
                data: {
                    label: RouteLabels.REPORT_CLOSING,
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                },
            },
            {
                path: `${Paths.PROJECT_ID}`,
                component: FinancialStatementEditPage,
                loadChildren: () =>
                    import(
                        '../../microservices/ms-annual-reports/financial-statement-edit/financial-statement-edit.module'
                    ).then((m) => m.FinancialStatementEditModule),
                canActivate: [AuthGuard],
                data: {
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                },
            },
            { path: '**', component: PageNotFoundComponent },
        ],
    },
];

@NgModule({
    imports: [CommonModule, I18NextModule, RouterModule.forChild(routes)],
})
export class AbcpModule {}
